// extracted by mini-css-extract-plugin
module.exports = {"item":"external_item__FLHdf","hovered":"external_hovered__z0wbC","initial":"external_initial__cJkHs"};